import {config} from "../../config";

export const projectConfiguration = {
    namespaced: true,
    state: config,

    getters: {
        URL_FOR_STATIC: state => {
            return state.urlForStatic;
        },
        URL_FOR_REQUEST: state => {
            return state.urlForRequest;
        },
        REQUEST_FROM_NGINX: state => {
            return state.requestFromNginx;
        },
        URL_FOR_FILE: state => {
            return state.urlForFile;
        },
        URL_FOR_FILE_NGINX: state => {
            return state.urlForFileNginx;
        },
        GENERATE_URL: state => (urlPart, disableNginxFlag) => {
            if (!urlPart)
                return state.urlForStatic + 'img/No_Picture.jpg';

            if (urlPart.startsWith("data"))
                return urlPart;

            let urlPartJpg;
            urlPartJpg = urlPart.replace('.png','.jpg')
            if (urlPartJpg !== urlPart)
                console.warn(".png replaced to jpg");
            if(state.requestFromNginx && !disableNginxFlag) {
                let catalog_1 = urlPartJpg.slice(0, 2);
                let catalog_2 = urlPartJpg.slice(2, 4);
                let catalog_3 = urlPartJpg.slice(4, 6);
                let file_name = urlPartJpg.slice(6, urlPartJpg.length);
                return state.urlForFileNginx + catalog_1 + '/' + catalog_2 + '/' + catalog_3 + '/' + file_name;
            }

            if(!state.requestFromNginx || disableNginxFlag) {
                return state.urlForFile + urlPartJpg;
            }
        }
    }
}
